import { gql } from "__generated__/gql";

export const DOSSIER_QUERY = gql(`#graphql
query getDossier($id: Long!) {
    dossier(charterId: $id) {
        charter {
            id
            charterNumber
            type
            subtype
            relationType
            declarations {
                id
                invoiceGroupType {
                    id
                }
                lastStatusChange {
                    ...statusChangeFragment
                }
                statusChanges {
                    ...statusChangeFragment
                }
                invoiceLines {
                    id
                    quantity
                    price {
                        currency {
                            isoCode
                            symbol
                        }
                        value
                    }
                }
                declarationValues {
                    id
                    agreement {
                        id
                        calculateAmount(charterId: $id)
                    }
                    quantity
                }
            }
            creditor {
                id
                name
                applicationRelation
                customer
                operator
                shipManger
                isShipManager
                supplier
                contacts {
                    id
                    type
                    name
                    insertion
                    surName
                    email
                    contactRoleTypes
                    visibleForShip
                }
            }
            debtor {
                id
                name
                applicationRelation
                customer
                operator
                shipManger
                isShipManager
                supplier
                contacts {
                    id
                    type
                    name
                    insertion
                    surName
                    email
                    contactRoleTypes
                    visibleForShip
                }
            }
            contractShips {
                id
                name
            }
            ... on SalesCharter {
                ...ShipNominationStatusChangeSalesCharter
                ...SalesCharterStatusChangeSalesCharter
                hasApplicableContract
                firstLoadingDate
                totalLaytime
                totalCleaningLaytime
                totalLoadingLaytime
                totalDischargingLaytime
                totalNitrogenPurgingLaytime
                laytimeRemarks
                excessLaytime
                demurrage
                purchaseCharter {
                    id
                    type
                    subtype
                    charterNumber
                }
                minimumShipNominationDays
                shipNominationPeriodRegime
                shortNotice
                customerNotes
                internalNotes
                customerReference
                dossierNumber
                blDate
                blDateOverride
                contacts {
                    contactRoleType
                    contact {
                        id
                        type
                        name
                        insertion
                        surName
                        email
                    }
                }
                validFrom
                validUntil
                broker {
                    id
                    name
                    contacts {
                        id
                        type
                        name
                        insertion
                        surName
                        email
                    }
                }
                cargos {
                    id
                    cargoNumber
                    containerNumber
                    weight
                    isWeightPrimary
                    totalLoadingWeight
                    declaredFinalWeight
                    volume
                    isVolumePrimary
                    waterLevelOptimised
                    empty
                    desiredTemperature
                    ...CargoServices
                    containerType {
                        isoTypeCode
                        displayCode
                        lengthFt
                        teu
                    }
                    product {
                        ...productWithGoods
                    }
                    lastStatusChange {
                        ...statusChangeFragment
                    }
                    statusChanges {
                        ...statusChangeFragment
                    }
                    productDetails
                    loadingReference
                    dischargingReference
                    nominationNumber
                    voyage {
                        id
                        voyageNumber
                        from {
                            id
                            code
                            description
                            displayCode
                        }
                        to {
                            id
                            code
                            description
                            displayCode
                        }
                    }
                    actions {
                        id
                        displayAsWindow
                        connectingVisitNotes
                        simulatedTimestamp
                        start
                        end
                        weight
                        volume
                        type
                        ...cargoActionActuals
                        location {
                            id
                            description
                            code
                            type
                            locationGroups {
                                id
                                description
                                code
                                type
                            }
                        }
                        shipToShip
                        connectingShipPortVisit {
                            ...GeneralConnectingShipPortVisit
                        }
                        connectingShipBerthing {
                            id
                            window {
                                from
                                to
                            }
                            location {
                                id
                                description
                                locationGroups {
                                    id
                                    description
                                    type
                                }
                            }
                            connectingShipPortVisit {
                                id
                            }
                        }
                        surveyor {
                            id
                            name
                        }
                        reference
                        notes
                        terminalPlanningNotes
                        connectingVisitNotes
                        call {
                            id
                            atd
                        }
                        includedForLaytimeCalculation
                    }
                    firstLoadingAction {
                        id
                        connectingVisitNotes
                        start
                        end
                        displayAsWindow
                        simulatedTimestamp
                        weight
                        volume
                        type
                        ...cargoActionActuals
                        location {
                            id
                            description
                            code
                            type
                            locationGroups {
                                id
                                description
                                code
                                type
                            }
                        }
                        connectingShipPortVisit {
                            ...GeneralConnectingShipPortVisit
                        }
                        connectingShipBerthing {
                            id
                            window {
                                from
                                to
                            }
                            location {
                                id
                                description
                                locationGroups {
                                    id
                                    description
                                    type
                                }
                            }
                        }
                        reference
                        surveyor {
                            id
                            name
                        }
                        notes
                        shipToShip
                    }
                    lastDischargingAction {
                        id
                        connectingVisitNotes
                        start
                        end
                        displayAsWindow
                        simulatedTimestamp
                        weight
                        volume
                        type
                        location {
                            id
                            description
                            code
                            type
                            locationGroups {
                                id
                                description
                                code
                                type
                            }
                        }
                        connectingShipPortVisit {
                            ...GeneralConnectingShipPortVisit
                        }
                        connectingShipBerthing {
                            id
                            window {
                                from
                                to
                            }
                            location {
                                id
                                description
                                locationGroups {
                                    id
                                    description
                                    type
                                }
                            }
                        }
                        reference
                        surveyor {
                            id
                            name
                        }
                        notes
                        shipToShip
                    }
                    consignee {
                        id
                        name
                    }
                    consignor {
                        id
                        name
                    }
                    containerOperator {
                        id
                        name
                    }
                    supplier {
                        id
                        name
                    }
                    comments {
                        ...comment
                    }
                    deliveryCondition {
                        id
                        key
                        description
                    }
                    dimensions {
                        height
                        length
                        width
                    }
                    teu
                    charter {
                        id
                        charterNumber
                    }
                    nominatedWeight
                    nominatedVolume
                    customerTransportDocument {
                        id
                        documentType
                        filename
                    }
                    totalLoadedWeight
                }
                voyages {
                    id
                    voyageNumber
                    isThirdParty
                    creditor {
                        id
                        name
                        email
                        contacts {
                            id
                            name
                            email
                            communicateStatusChanges
                        }
                    }
                    ship {
                        id
                        name
                        bargeType
                        tanks {
                            id
                            positionNumber
                            position
                        }
                        tankProperties {
                            tankConfiguration
                        }
                        operator {
                            id
                            name
                            email
                            applicationRelation
                            contacts {
                                id
                                name
                                email
                                communicateStatusChanges
                            }
                        }
                        owner {
                            id
                            name
                            email
                            contacts {
                                id
                                name
                                email
                                communicateStatusChanges
                            }
                        }
                        shipManager {
                            id
                            name
                            email
                            contacts {
                                id
                                name
                                email
                                communicateStatusChanges
                            }
                        }
                        skipper {
                            id
                            name
                            email
                            contacts {
                                id
                                name
                                email
                                communicateStatusChanges
                            }
                        }
                        contacts {
                            email
                        }
                    }
                    calls {
                        id
                        comments {
                            ...comment
                        }
                        location {
                            id
                            description
                        }
                        voyage {
                            id
                            voyageNumber
                        }
                        createTwinCall
                    }
                    lastStatusChange {
                        status {
                            ...statusFragment
                        }
                    }
                    lastShippedProducts {
                        ...productWithGoods
                    }
                    lastShippedProductsFreeText
                    ship {
                        id
                        name
                        bargeType
                        tanks {
                            id
                            positionNumber
                        }
                    }
                }
            }
            allContracts {
                id
            }
            ... on PurchaseCharter {
                validFrom
                validUntil
                voyages {
                    id
                    voyageNumber
                    isThirdParty
                    creditor {
                        id
                        name
                        email
                    }
                    calls {
                        id
                        cargos {
                            id
                        }
                        comments {
                            ...comment
                        }
                        location {
                            id
                            description
                        }
                        voyage {
                            id
                            voyageNumber
                        }
                        createTwinCall
                    }
                    purchaseCharters {
                        id
                        type
                        subtype
                    }
                    cargos {
                        id
                        cargoNumber
                        product {
                            ...productWithGoods
                        }
                        productDetails
                        loadingReference
                        dischargingReference
                        voyage {
                            id
                            voyageNumber
                            from {
                                id
                                code
                                description
                                displayCode
                            }
                            to {
                                id
                                code
                                description
                                displayCode
                            }
                        }
                        actions {
                            id
                            connectingVisitNotes
                            start
                            end
                            displayAsWindow
                            simulatedTimestamp
                            weight
                            volume
                            type
                            location {
                                id
                                description
                                code
                                type
                                locationGroups {
                                    id
                                    description
                                    code
                                    type
                                }
                            }
                            shipToShip
                            connectingShipPortVisit {
                                ...GeneralConnectingShipPortVisit
                            }
                            surveyor {
                                id
                                name
                            }
                            reference
                            notes
                            call {
                                id
                                atd
                            }
                            includedForLaytimeCalculation
                        }
                        consignee {
                            id
                            name
                        }
                        consignor {
                            id
                            name
                        }
                        supplier {
                            id
                            name
                        }
                        comments {
                            ...comment
                        }
                        deliveryCondition {
                            id
                            key
                            description
                        }
                        dimensions {
                            height
                            length
                            width
                        }
                        teu
                        charter {
                            id
                            charterNumber
                        }
                    }
                    ship {
                        id
                        name
                        capacityM3
                        capacityTon
                        lengthCm
                        widthCm
                        position {
                            latitude
                            longitude
                            locationEntered
                            location
                            course
                        }
                        lastShippedProducts {
                            ...productWithGoods
                        }
                        availability {
                            ...availabilityFragment
                        }
                        workingHours {
                            id
                            mondayFrom
                            mondayTo
                            tuesdayFrom
                            tuesdayTo
                            wednesdayFrom
                            wednesdayTo
                            thursdayFrom
                            thursdayTo
                            fridayFrom
                            fridayTo
                            saturdayFrom
                            saturdayTo
                            sundayFrom
                            sundayTo
                        }
                        bargeType
                        tanks {
                            id
                            positionNumber
                        }
                    }
                    lastShippedProducts {
                        ...productWithGoods
                    }
                    lastShippedProductsFreeText
					expired
					finished
                }
            }
            contract {
                ...charterContractFragment
                agreements {
                    ...agreementFragment
                    ... on DemurrageCalculationAgreement {
                        calculateAmount(charterId: $id)
                    }
                }
            }
            allContracts {
                ...charterContractFragment
                agreements {
                    ...agreementFragment
                    ... on DemurrageCalculationAgreement {
                        calculateAmount(charterId: $id)
                    }
                }
            }
        }
        charters {
            id
            charterNumber
            type
            subtype
            relationType
            creditor {
                id
                name
                applicationRelation
                customer
                operator
                shipManger
                isShipManager
                supplier
                contacts {
                    id
                    type
                    name
                    insertion
                    surName
                    email
                    visibleForShip
                }
            }
            debtor {
                id
                name
                applicationRelation
                customer
                operator
                shipManger
                isShipManager
                supplier
                contacts {
                    id
                    type
                    name
                    insertion
                    surName
                    email
                    visibleForShip
                }
            }
            contractShips {
                id
                name
            }
            contract {
                ...charterContractFragment
            }
            allContracts {
                ...charterContractFragment
                agreements {
                    ...agreementFragment
                    ... on DemurrageCalculationAgreement {
                        calculateAmount(charterId: $id)
                    }
                }
            }
            ... on PurchaseCharter {
                validFrom
                validUntil
                voyages(from: null, to: null, excludeEmpty: false, rootCharterId: $id) {
                    id
                    voyageNumber
                    purchaseCharters {
                        id
                        charterNumber
                        type
                        subtype
                    }
                    cargos {
                        id
                        charter {
                            id
                            charterNumber
                        }
                    }
                    creditor {
                        id
                        name
                    }
                    calls {
                        id
                        cargos {
                            id
                            weight
                            volume
                        }
                        comments {
                            ...comment
                        }
                        location {
                            id
                            description
                        }
                        voyage {
                            id
                            voyageNumber
                        }
                        createTwinCall
                    }
                    ship {
                        id
                        name
                        capacityM3
                        capacityTon
                        lengthCm
                        widthCm
                        position {
                            latitude
                            longitude
                            locationEntered
                            location
                            course
                        }
                        lastShippedProducts {
                            ...productWithGoods
                        }
                        availability {
                            ...availabilityFragment
                        }
                        workingHours {
                            id
                            mondayFrom
                            mondayTo
                            tuesdayFrom
                            tuesdayTo
                            wednesdayFrom
                            wednesdayTo
                            thursdayFrom
                            thursdayTo
                            fridayFrom
                            fridayTo
                            saturdayFrom
                            saturdayTo
                            sundayFrom
                            sundayTo
                        }
                        bargeType
                        tanks {
                            id
                            positionNumber
                            position
                        }
                        tankProperties {
                            tankConfiguration
                        }
                    }
                    lastShippedProducts {
                        ...productWithGoods
                    }
                    lastShippedProductsFreeText
					expired
					finished
                }
            }
            ... on SalesCharter {
                broker {
                    id
                    name
                    contacts {
                        id
                        type
                        name
                        insertion
                        surName
                        email
                    }
                }
                minimumShipNominationDays
                shipNominationPeriodRegime
                shortNotice
                customerNotes
                internalNotes
                status {
                    name
                    color
                    languageKeyPrefix
                }
                blDate
                contacts {
                    contactRoleType
                    contact {
                        id
                        type
                        name
                        insertion
                        surName
                        email
                        visibleForShip
                    }
                }
                cargos {
                    id
                    cargoNumber
                    product {
                        ...productWithGoods
                    }
                    productDetails
                    loadingReference
                    dischargingReference
                    actions {
                        id
                        displayAsWindow
                        connectingVisitNotes
                        simulatedTimestamp
                        start
                        end
                        weight
                        volume
                        type
                        ...cargoActionActuals
                        location {
                            id
                            description
                            code
                            type
                            locationGroups {
                                id
                                description
                                code
                                type
                            }
                        }
                        shipToShip
                        connectingShipPortVisit {
                            ...GeneralConnectingShipPortVisit
                        }
                        surveyor {
                            id
                            name
                        }
                        reference
                        notes
                        call {
                            id
                            atd
                        }
                    }
                    consignee {
                        id
                        name
                    }
                    consignor {
                        id
                        name
                    }
                    supplier {
                        id
                        name
                    }
                    comments {
                        ...comment
                    }
                    deliveryCondition {
                        id
                        key
                        description
                    }
                    dimensions {
                        height
                        length
                        width
                    }
                    teu
                    totalLoadedWeight
                }
                totalLaytime
                totalCleaningLaytime
                totalLoadingLaytime
                totalDischargingLaytime
                totalNitrogenPurgingLaytime
                laytimeRemarks
            }
        }
    }
}
`);
